import { combineReducers } from 'redux'

import { reducer as categoryList } from './categoryList'
import { reducer as post } from './post'
import { reducer as postsByTag } from './postsByTag'

export const reducer = combineReducers({
  categoryList,
  post,
  postsByTag
})
